import React from 'react'
import { FolderCloseIcon, TagIcon } from '../../Components/LandingHeader/Feedback/icons/Icons'
import _ from 'lodash'
import { Link } from 'react-router-dom'

const ProjectTagIcon = ({task, opacity = '70'}) => {
  return (
    <>
        {task?.Project?.title && (
            <span
            key={"task-" + task.id}
            className="flex items-center justify-center gap-[5px]"
            >
            <FolderCloseIcon />
            <span className={`font text-xs font-inter`} style={{letterSpacing: 'normal'}}>
                {
                    task?.Project?.project_id 
                    ?
                    <Link className={`font text-black dark:text-white2 opacity-${opacity}`} to={`/tasks/projects/${task.Project.title}/${task.Project.project_id}${task.Project?.projectSource ? `_${task.Project.projectSource}` : ''}`}>{task.Project.title}</Link>
                    :
                    task.Project.title
                }
            </span>
            </span>
        )}
        {task.Tags &&
            task.Tags.map(({ name, tagId }) => (
            <span
                key={tagId}
                className="flex items-center justify-center gap-[5px]"
            >
                <TagIcon />
                <span className={`font text-xs font-inter text-black opacity ${opacity} text-sm`} style={{letterSpacing: 'normal'}}>
                {_.capitalize(name)}
                </span>
            </span>
        ))}
    </>
  )
}

export default ProjectTagIcon